const _globalUtils = {
    isEmpty: function (str) {
        if (str.replace(/ /g, '')) {
            return false;
        }
        return true;
    },
    showDateFromUnix: function (intValue, strFormat = 'DD/MM/YYYY HH:mm:ss') {
        return moment.unix(intValue).format(strFormat);
    },
    showTextArea: function (str) {
        return this.htmlEncode(str.replace(/\r\n|\r|\n/g, '<br />'));
    },
    htmlEncode: function (html) {
        html = $.trim(html);
        return html.replace(/[&"'\<\>]/g, function (c) {
            switch (c) {
                case '&':
                    return '&amp;';
                case "'":
                    return '&#39;';
                case '"':
                    return '&quot;';
                case '<':
                    return '&lt;';
                default:
                    return '&gt;';
            }
        });
    },
};
